import { ATTENDEE_PARTICIPANT_TYPES } from './constants';
import { ALL_VALID_RANKS, ALL_SERVICE_BRANCH_VALUES } from './military-constants';

const ATTENDEE_PARTICIPANT_TYPE_VALUES = ATTENDEE_PARTICIPANT_TYPES.map((p) => p.value) as readonly string[];

export const BIO_MAX = 300;

export function safeRank(value: unknown): string {
  return typeof value === 'string' && ALL_VALID_RANKS.includes(value) ? value : '';
}

export function safeBranch(value: unknown): string {
  return typeof value === 'string' && ALL_SERVICE_BRANCH_VALUES.includes(value) ? value : '';
}

export function safeAttendeeParticipantType(value: unknown): string {
  return typeof value === 'string' && ATTENDEE_PARTICIPANT_TYPE_VALUES.includes(value) ? value : '';
}

export function safeBio(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.length > BIO_MAX ? value.slice(0, BIO_MAX) : value;
}

export function safeUrl(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
    return value;
  } catch {
    return '';
  }
}
